export default (function (obj) {
  return obj && obj.__isYupSchema__;
});